import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsFieldLayoutSchemesRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-fieldlayouts-schemes-view',
	path: '/secure/admin/ViewFieldLayoutSchemes.jspa',
};
